<template>
  <section class="browse-attorneys bg-light-blue mb-0 pt-4 section">
    <div class="container">
      <div class="section-head">
        <h3 class="section-title">
          Browse Lawyers
        </h3>
      </div>
      <div class="wrapper">
        <ul class="main-list">
          <BrowseByName
            :active="currentActiveComponent"
            @changeActiveComponent="changeActiveComponent('ByName')"
          />
          <BrowseByPracticeArea
            :active="currentActiveComponent"
            @changeActiveComponent="changeActiveComponent('ByPracticeArea')"
          />
          <BrowseByCity
            :active="currentActiveComponent"
            @changeActiveComponent="changeActiveComponent('ByCity')"
          />
        </ul>
      </div>
    </div>
  </section>
</template>


<script>
import {ref} from 'vue'
import BrowseByName from './BrowseByName.vue'
import BrowseByPracticeArea from './BrowseByPracticeArea.vue'
import BrowseByCity from './BrowseByCity.vue'

export default {
  name: 'BrowseAttorneys',
  components: {
    BrowseByName,
    BrowseByPracticeArea,
    BrowseByCity,
  },

  setup() {
    const currentActiveComponent = ref('ByName')

    const changeActiveComponent = (componentName) => {
      if (currentActiveComponent.value === componentName) {
        currentActiveComponent.value = ''
      } else {
        currentActiveComponent.value = componentName
      }
    }

    return {
      currentActiveComponent,
      changeActiveComponent,
    }
  },
}
</script>
<style scoped>
  .container{
    padding: 0;
  }
</style>
